import { useSyncExternalStore } from 'react';
import { UI_GLASS } from './shared';
import { hasNativePlugin, isNative } from '@/lib/native/is-native';

/**
 * Liquid Glass A/B: is this page on variant B? Read from the `data-ui`
 * attribute on <html> (set by AuthedShell, see ./shared.ts), so it follows a
 * super-admin's toggle without a reload. For the few places where B needs
 * different STRUCTURE, not just different CSS — everything else should stay
 * a `:root[data-ui="glass"]` rule.
 *
 * False on the server and through hydration, then true where it applies, so
 * the server HTML never disagrees with the first client render.
 */
function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-ui', 'data-ui-native'] });
  return () => observer.disconnect();
}

const isGlass = () => document.documentElement.dataset.ui === UI_GLASS;

export function useUiGlass(): boolean {
  return useSyncExternalStore(subscribe, isGlass, () => false);
}

const isGlassNative = () =>
  isGlass() &&
  document.documentElement.dataset.uiNative === '1' &&
  isNative() &&
  hasNativePlugin('MuckaGlassBar');

/**
 * The native glass bar trial (PR 4, docs/liquid-glass-native-bar-plan.md):
 * variant B, `accounts.ui_glass_native` on, AND an app build that has the
 * plugin. Any one missing and the web glass bar stays, so an old binary or a
 * browser can never be left with no bar at all.
 */
export function useUiGlassNative(): boolean {
  return useSyncExternalStore(subscribe, isGlassNative, () => false);
}
